import React from 'react'


//helper function, send the database and outputs an array of assignment options based on how much elements are in the array
export function CreateAssignmentOptions(dbArray) {
    let assignmentOptions = [];
    for(let i = 0; i < dbArray.length; i++) {
        assignmentOptions.push({
            key: i,
            text: 'Assignment ' + (i+1),
            value: i
        })
    }
    return assignmentOptions;
}
